import { styled } from "@material-ui/core/styles";
import theme from "../constants/theme";
import { Paper } from "@material-ui/core";

export default styled(Paper)({
  padding: theme.spacing(4),
  textAlign: "center",
  borderRadius: 0,
});
